import {
  SET_USER_FINISHED,
} from "../actionTypes";

export default function setUserFinished() {
  return {
    type: SET_USER_FINISHED,
  };
}
